import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Record = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M20.344 12.416a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0m-8.25 4.35a4.35 4.35 0 1 0 0-8.7 4.35 4.35 0 0 0 0 8.7'
        stroke='currentColor'
        strokeWidth='1.5'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.094 21.416a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0-5.4a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2'
        fill='currentColor'
      />
    )}
  </IconBase>
);
